import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import detectBrowserLanguage from 'detect-browser-language';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSpinner, faLink, faArrowUp, faPlus } from '@fortawesome/free-solid-svg-icons';
import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import ja from 'react-intl/locale-data/ja';
import 'react-toastify/dist/ReactToastify.css';
import { setLang } from '../services/App/actions';
import config from '../config';
import StoreProvider from '../services/storeProvider';
import Routes from '../routes';
import './App.scss';

// Add icons
library.add(faSpinner);
library.add(faLink);
library.add(faArrowUp);
library.add(faPlus);

export default class Application extends React.Component {
  static propTypes = {
    platformReducers: PropTypes.shape(),
    platformSagas: PropTypes.arrayOf(PropTypes.shape()),
    platformInitializers: PropTypes.arrayOf(PropTypes.func),
    platformMiddlewares: PropTypes.arrayOf(PropTypes.shape()),
  }

  static defaultProps = {
    platformReducers: {},
    platformSagas: [],
    platformInitializers: [],
    platformMiddlewares: [],
  }

  constructor(props) {
    super(props);
    // Init store
    this.setStore();

    ReactGA.initialize(config.GOOGLE_ANALYTICS, {
      // debug: process.env.NODE_ENV !== 'production',
    });

    // eslint-disable-next-line no-undef
    ReactGA.pageview(window.location.pathname + window.location.search);

    // Add localizations
    addLocaleData([
      ...en,
      ...ja,
    ]);
  }

  state = {
    initialized: false,
  }

  componentWillMount() {
    // Set default lanuage
    this.store.dispatch(setLang(detectBrowserLanguage().slice(0, 2)));

    // Wait for all async init actions and set initialized flag to true after
    Promise.all(this.initPromises()).then(() => {
      // Turn on http errors alert box display
      // HttpInterceptorService.initializedErrorsInterceptor(this.store);
      // Turn on logout when session is expired
      // HttpInterceptorService.initializeNonAuthenticatedInterceptor(this.store);
      // Check authentication, then do actions and init
      this.setState(() => ({
        initialized: true,
      }));
    });
  }

  componentDidMount() {
    // Track app performance
    // eslint-disable-next-line no-undef
    if (window.performance) {
      // Gets the ms since page load.
      // eslint-disable-next-line no-undef
      const timeSince = Math.round(window.performance.now());

      ReactGA.timing({
        category: 'Application loaded',
        variable: 'load',
        value: timeSince,
      });
    }
  }

  setStore() {
    const {
      platformReducers,
      platformSagas,
      platformMiddlewares,
    } = this.props;

    this.store = StoreProvider.getInstance({
      platformReducers,
      platformSagas,
      platformMiddlewares,
    });
  }

  store = {};

  initPromises() {
    const { platformInitializers } = this.props;
    let initPromises = [];
    const platformInitPromises = (platformInitializers || []).map(initializer => initializer());
    initPromises = initPromises.concat(platformInitPromises);
    return initPromises;
  }

  render() {
    return (
      <Fragment>
        {this.state.initialized ? (
          <Provider store={this.store}>
            <HashRouter>
              <Routes />
            </HashRouter>
          </Provider>
        ) : null}
      </Fragment>
    );
  }
}
